import { Component } from '@angular/core';
import { AppState } from '../../../app/app.global';
import { VersionService } from '../../../providers/util/versionservice';

@Component({
  selector: 'version-update-page',
  templateUrl: 'updateversion.html'
})
export class VersionUpdatePage {
  isNeedUpdate:boolean = true;
  currentVersionCode:any;
  latestVersionCode:any;
	
	constructor (public global: AppState, private versionService:VersionService) {
    
  }

  ionViewWillEnter(){
    this.compareVersionCode();
  }

  /**
   * 比较版本
   */
  compareVersionCode(){
    this.currentVersionCode = localStorage.getItem("currentVersionCode");
    this.latestVersionCode = localStorage.getItem("latestVersionCode");
    if(this.currentVersionCode < this.latestVersionCode){
      this.isNeedUpdate = true;
    }else{
      this.isNeedUpdate = false;
    }

  }
  
  /**
   * 更新版本
   */
  updateVersion(){
    this.versionService.checkUpdate(false);
  }

}


// WEBPACK FOOTER //
// ./src/pages/about/version/updateversion.ts